<div mat-dialog-content class="text_class">
  <div [innerHTML]="'login.cookiespolicy.text' | translate">{{'login.cookiespolicy.text' | translate }}</div>

</div>
<div mat-dialog-actions style="text-align: center" align="center">
  <button mat-raised-button class="submit-button" color="accent" (click)="onAcceptClick()">{{'login.cookiespolicy.accept' | translate }}</button>
</div>
